// ATTN we use this constants in data dump
const abTests = {
  homeFullNav: 'home:fullNav', // CRO-33
  partytown: 'partytown', // PF-1366
  upchargeInfoPayment: 'UpchargeInfoPayment', // PF-1397
  spPlans: 'sp:plans', // CRO-68
  queueWidget: 'queueWidget', // CRO-40
  mainLeadView: 'main:leadView', // CRO-38
  catStickyRow: 'cat:stickyRow', // CRO-66
  subCartOffer: 'sub:cartOffer', // CRO-78
  upgradePage: 'upgradePage', // CRO-83
} as const

export type AbTestName = typeof abTests[keyof typeof abTests]


export default abTests
